import { render, staticRenderFns } from "./app-badge.vue?vue&type=template&id=43bc79ac&scoped=true&"
import script from "./app-badge.vue?vue&type=script&lang=js&"
export * from "./app-badge.vue?vue&type=script&lang=js&"
import style0 from "./app-badge.vue?vue&type=style&index=0&id=43bc79ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc79ac",
  null
  
)

export default component.exports